<template>
  <div class="sp-template">
    <div class="h-title">商品列表</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="querySkuForm" class="demo-form-inline" size="small">
          <el-form-item label="产品SKU">
            <el-input v-model.lazy="querySkuForm.sku" placeholder="产品SKU"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.lazy="querySkuForm.name" placeholder="产品名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(305)" type="primary" @click="onSubmit">搜 索</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button size="small" v-if="in_configs(301)" class="el-button btn-cyan" @click="addSkuDialog()"> 新建商品</el-button>
          <!-- <el-button size="small" v-if="in_configs(302)" type="primary"> 批量上传</el-button> -->
        </div>
      </div>
      <el-table :data="skuData" stripe>
        <el-table-column prop="sku" label="产品SKU"></el-table-column>
        <el-table-column prop="nameCn" label="中文品名"></el-table-column>
        <el-table-column prop="nameEn" label="英文品名"></el-table-column>
        <el-table-column prop="hscode" label="中国海关编码"></el-table-column>
        <el-table-column prop="euHsCode" label="欧盟海关编码"></el-table-column>
        <el-table-column prop="brand" label="品牌"></el-table-column>
        <el-table-column prop="material" label="材质"></el-table-column>
        <el-table-column prop="purpose" label="用途"></el-table-column>
        <el-table-column prop="asin" label="ASIN或销售链接"></el-table-column>
        <el-table-column prop="model" label="型号"></el-table-column>
        <el-table-column prop="price" label="申报价值"></el-table-column>
        <el-table-column prop="length" label="长"></el-table-column>
        <el-table-column prop="width" label="宽"></el-table-column>
        <el-table-column prop="height" label="高"></el-table-column>
        <el-table-column prop="weight" label="单个毛重"></el-table-column>
        <el-table-column prop="singleNetWeight" label="单个净重"></el-table-column>
        <el-table-column label="SKU图片">
          <template slot-scope="scope">
            <!-- <img width="65" height="45" :src="scope.row.pictureUrl"> -->
            <sp-img :url-arr="scope.row.pictureUrl" show-one @get-urlArr="getUrlArr" @active-index="getActiveIndex" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-edit-outline" v-if="in_configs(303)" @click="addSkuDialog( scope.row)"></i>
            <!-- <i class="el-icon-delete" v-if="in_configs(304)" @click="handleDelete( scope.row)"></i> -->
          </template>
        </el-table-column>
      </el-table>
      <sp-dialog title="" name="" :visible.sync="skuPictureVisible">
        <sp-img-content name="" :urlArr="skuImgArr" :activeIndex="activeIndex" @active-index="getActiveIndex"></sp-img-content>
      </sp-dialog>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <!-- 添加sku -->
    <el-dialog title="sku" :visible.sync="dialogGoodsFormVisible" :show-close='false'>
      <el-form :model="skuForm" size="small" id="uploadForm" :rules="skuFormRule" ref="skuForm">
        <el-form-item label="产品SKU" :label-width="formLabelWidth" prop="sku">
          <el-input v-model.trim="skuForm.sku" placeholder="产品SKU"></el-input>
        </el-form-item>
        <el-form-item label="中文品名" :label-width="formLabelWidth" prop="nameCn">
          <el-input v-model.lazy="skuForm.nameCn" placeholder="中文品名"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" :label-width="formLabelWidth" prop="nameEn">
          <el-input v-model.lazy="skuForm.nameEn" placeholder="英文品名"></el-input>
        </el-form-item>
        <el-form-item label="长(cm)" :label-width="formLabelWidth" prop="length">
          <el-input v-model.lazy="skuForm.length" type="number" placeholder="长"></el-input>
        </el-form-item>
        <el-form-item label="宽(cm)" :label-width="formLabelWidth" prop="width">
          <el-input v-model.lazy="skuForm.width" type="number" placeholder="宽"></el-input>
        </el-form-item>
        <el-form-item label="高(cm)" :label-width="formLabelWidth" prop="height">
          <el-input v-model.lazy="skuForm.height" type="number" placeholder="高"></el-input>
        </el-form-item>
        <el-form-item label="单个净重(kg)" :label-width="formLabelWidth" prop="singleNetWeight">
          <el-input v-model.lazy="skuForm.singleNetWeight" type="number" placeholder="单个净重"></el-input>
        </el-form-item>
        <el-form-item label="单个毛重(kg)" :label-width="formLabelWidth" prop="weight">
          <el-input v-model.lazy="skuForm.weight" type="number" placeholder="单个毛重"></el-input>
        </el-form-item>
        <el-form-item label="中国海关编码" :label-width="formLabelWidth" prop="hscode">
          <el-input v-model.lazy="skuForm.hscode" placeholder="海关编码"></el-input>
        </el-form-item>
        <el-form-item label="目的国海关编码" :label-width="formLabelWidth" prop="euHsCode">
          <el-input v-model.lazy="skuForm.euHsCode" placeholder="目的国海关编码"></el-input>
        </el-form-item>
        <el-form-item label="品牌" :label-width="formLabelWidth" prop="brand">
          <el-input v-model.lazy="skuForm.brand" placeholder="品牌"></el-input>
        </el-form-item>
        <el-form-item label="材质" :label-width="formLabelWidth" prop="material">
          <el-input v-model.lazy="skuForm.material" placeholder="材质"></el-input>
        </el-form-item>
        <el-form-item label="用途" :label-width="formLabelWidth" prop="purpose">
          <el-input v-model.lazy="skuForm.purpose" placeholder="用途"></el-input>
        </el-form-item>
        <el-form-item label="ASIN或销售链接" :label-width="formLabelWidth" prop="asin">
          <el-input v-model.lazy="skuForm.asin" placeholder="ASIN或销售链接"></el-input>
        </el-form-item>
        <el-form-item label="型号" :label-width="formLabelWidth" prop="model">
          <el-input v-model.lazy="skuForm.model" placeholder="型号"></el-input>
        </el-form-item>
        <el-form-item label="单个产品申报价值" :label-width="formLabelWidth" prop="price">
          <el-row>
            <el-col :span="5">
              <el-select v-model.lazy="skuForm.currency" class="width:500px">
                <el-option v-for="(d, i) in currencys" :key="i" :label="d.label" :value="d.value"></el-option>
              </el-select>
            </el-col>
            <el-col :span="15" class="width100">
              <el-input v-model.lazy="skuForm.price" type="number" placeholder="单个产品申报价值"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="原图片" v-show="skuForm.pictureUrl" :label-width="formLabelWidth">
          <sp-img :url-arr="skuForm.pictureUrl" show-one @get-urlArr="getUrlArr" @active-index="getActiveIndex" />
        </el-form-item>
        <el-form-item label="商品图片" :label-width="formLabelWidth" >
          <!-- 上传图片 -->
          <el-upload action="#" ref="upload" list-type="picture-card" :limit="1" accept=".jpg,.png,.jpeg" :on-change="handlePictureCardChange" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogGoodsFormVisible=false">取 消</el-button>
        <el-button type="primary" @click="addAndEdit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogGoodsFormVisible: false,
      formLabelWidth: "120px",
      dialogFormVisible: false,
      multipleSelection: [],
      skuData: [],
      dialogVisible: false,
      querySkuForm: {
        sku: "",
        name: ""
      },
      goodsImgs: "",
      dialogImageUrl: [],
      skuForm: {
        id: ""
      },
      currencys: [
        {
          value: "RMB",
          label: "人民币"
        },
        {
          value: "HKD",
          label: "港币"
        },
        {
          value: "GBP",
          label: "英镑"
        },
        {
          value: "USD",
          label: "美元"
        },
        {
          value: "JPY",
          label: "日元"
        },
        {
          value: "EUR",
          label: "欧元"
        }
      ],
      skuPictureVisible: false,
      skuImgArr: [],
      activeIndex: null, //当前展示图片的index
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1, //当前页
      skuFormRule: {
        sku: [
          {
            required: true,
            message: "请填写SKU",
            trigger: "blur"
          }
        ],
        nameCn: [
          {
            required: true,
            message: "请填写中文名",
            trigger: "blur"
          }
        ],
        nameEn: [
          {
            required: true,
            message: "请填写英文名",
            trigger: "blur"
          }
        ],
        length: [
          {
            required: true,
            message: "请填写长",
            trigger: "blur"
          }
        ],
        width: [
          {
            required: true,
            message: "请填写宽",
            trigger: "blur"
          }
        ],
        height: [
          {
            required: true,
            message: "请填写高",
            trigger: "blur"
          }
        ],
        singleNetWeight: [
          {
            required: true,
            message: "请填写单个净重",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "请填写单个毛重",
            trigger: "blur"
          }
        ],
        hscode: [
          {
            required: true,
            message: "请填写海关编码",
            trigger: "blur"
          }
        ],
        euHsCode: [
          {
            required: true,
            message: "请填写目的国海关编码",
            trigger: "blur"
          }
        ],
        brand: [
          {
            required: true,
            message: "请填写品牌",
            trigger: "blur"
          }
        ],
        material: [
          {
            required: true,
            message: "请填写材质",
            trigger: "blur"
          }
        ],
        purpose: [
          {
            required: true,
            message: "请填写用途",
            trigger: "blur"
          }
        ],
        asin: [
          {
            required: true,
            message: "请填写ASIN",
            trigger: "blur"
          }
        ],
        model: [
          {
            required: true,
            message: "请填写型号",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "请填写单个产品申报价值",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  created() {
    this.query();
  },
  computed: {},
  methods: {
    getUrlArr(val) {
      let skuImgUrl = [];
      this.skuPictureVisible = true;
      this.skuImgArr != val && (this.skuImgArr = val);
    },
    //图片组件获取当前index
    getActiveIndex(index) {
      this.activeIndex = index;
      this.$nextTick(function() {
        this.title =
          this.skuImgArr.length > 0 && this.skuImgArr[index].title
            ? this.skuImgArr[index].title
            : "标题";
      });
      // console.log("图片组件获取当前index: " + index);
    },
    //搜索
    onSubmit() {
      this.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;
      this.$request1
        .post(
          '/sku/query',
          {
              sku: this.querySkuForm.sku,
              skuName: this.querySkuForm.name,
              currentPage: this.currentPage,
              pageSize: this.pageSize
            },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.skuData = [];
            if (res.data.total > 0) {
              res.data.data.forEach((sku, index) => {
                let pictureStr = sku.pictureUrl;
                let skuPictureUrl = [];
                if (pictureStr) {
                  skuPictureUrl.push(pictureStr);
                }
                _this.skuData.push({
                  currency: sku.currency,
                  length: sku.length,
                  width: sku.width,
                  height: sku.height,
                  weight: sku.weight,
                  id: sku.id,
                  sku: sku.sku,
                  nameCn: sku.nameCn,
                  nameEn: sku.nameEn,
                  hscode: sku.hscode,
                  euHsCode: sku.euHsCode,
                  brand: sku.brand,
                  material: sku.material,
                  purpose: sku.purpose,
                  asin: sku.asin,
                  model: sku.model,
                  price: sku.price,
                  singleNetWeight: sku.singleNetWeight,
                  pictureUrl: [sku.picture]
                });
              });
            }
            _this.total = res.data.total;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //添加sku
    addSkuDialog(row) {
      if (row) {
        this.skuForm = {
          currency: row.currency,
          id: row.id,
          sku: row.sku,
          nameCn: row.nameCn,
          nameEn: row.nameEn,
          length: row.length,
          width: row.width,
          height: row.height,
          weight: row.weight,
          hscode: row.hscode,
          euHsCode: row.euHsCode,
          brand: row.brand,
          material: row.material,
          purpose: row.purpose,
          asin: row.asin,
          model: row.model,
          price: row.price,
          singleNetWeight: row.singleNetWeight,
          pictureUrl: row.pictureUrl
        };
        console.log(row);
      } else {
        this.skuForm = {};
      }
      this.dialogGoodsFormVisible = true;
    },
    addAndEdit() {
      let _this = this;

      let _valid = true;
      _this.$refs["skuForm"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }

      let dataForm = this.getFormData(this.skuForm, this.goodsImgs);
      this.$request1({
        url: '/sku',
        method: 'POST',
        withCredentials: true,
        data: dataForm
      })
        .then(function(res) {
          console.log(res);
          if (res.data.success) {
            _this.query();
            _this.dialogGoodsFormVisible = false;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
          if(error.response.status === 413){
             _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          }else{
          _this.$notify.error({
                title: "请求失败,异常提示:",
                message: error.response.statusText,
                duration: 0
              });
          }
        });
    },
    getFormData(skuForm, pic) {
      var formData = new FormData();
      for (var key in skuForm) {
        formData.append(key, skuForm[key]);
      }
      formData.append("picture", pic);
      return formData;
    },

    //上传图片
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    handlePictureCardChange(file, fileList) {
      this.goodsImgs = file.raw;
    },
    //删除
    handleDelete(row) {
      let _this = this;
      let skuId = row.id;
      _this
        .$confirm("此操作将永久删除该商品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _this.$request1({
              url: '/sku/' + skuId + '/del',
              method: 'POST',
              withCredentials: true
            })
            .then(function(res) {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                _this.query();
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/goods/goodslist.vue